import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import Modal from 'components/ui/Modal';
import { CtaButton } from '../AfterSalesCtas.styles';
import { StyledButtonWrapper } from './ExchangeCtaOverride.styles.js';
import { ConfirmButton, CancelButton } from 'components/ui/Button';

const ExchangeCtaPackageBookingWarning = ({ isExchangeDisabled, label, onClick, hasInsurance = false }) => {
  const [showWarning, setShowWarning] = useState(false);

  const handleToggle = () => {
    setShowWarning(!showWarning);
  };

  const handleExchangeClick = () => onClick();

  return (
    <>
      <CtaButton
        type="button"
        data-cy="exchange-with-package-booking"
        data-id="exchange-with-package-booking"
        disabled={isExchangeDisabled}
        label={label}
        onClick={handleToggle}
      >
        {label}
      </CtaButton>

      {showWarning && (
        <Modal title={<FormattedMessage id="exchanges.packageBookingSelected" />} isOpen={showWarning} onClose={handleToggle}>
          <div>
            <FormattedMessage id="exchanges.packageBookingContinue" /> - <FormattedMessage id="exchanges.packageBookingSameDepartureDate" />
          </div>
          {hasInsurance && (
            <div>
              <FormattedMessage id="exchanges.insuranceWarning.title" /> - <FormattedMessage id="exchanges.insuranceWarning" />
            </div>
          )}

          <StyledButtonWrapper>
            <ConfirmButton
              data-testid="confirm-exchange-with-package-booking"
              data-cy="confirm-exchange-with-package-booking"
              onClick={handleExchangeClick}
            >
              <FormattedMessage id="exchanges.confirm" />
            </ConfirmButton>

            <CancelButton
              type="button"
              data-cy="cancel-exchange-with-package-booking"
              data-testid="cancel-exchange-with-package-booking"
              onClick={handleToggle}
            >
              <FormattedMessage id="vouchers.cancel" />
            </CancelButton>
          </StyledButtonWrapper>
        </Modal>
      )}
    </>
  );
};

ExchangeCtaPackageBookingWarning.propTypes = {
  isExchangeDisabled: PropTypes.bool,
  label: PropTypes.node,
  onClick: PropTypes.func,
  hasInsurance: PropTypes.bool
};

export default injectIntl(ExchangeCtaPackageBookingWarning);
